module.exports = __webpack_public_path__ + "static/img/BZ.1a5e0c52.png";